import { render } from "./6.Products.vue?vue&type=template&id=346a3c2a&scoped=true"
import script from "./6.Products.vue?vue&type=script&lang=js"
export * from "./6.Products.vue?vue&type=script&lang=js"

import "./6.Products.vue?vue&type=style&index=0&id=346a3c2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-346a3c2a"]])

export default __exports__